export class OrganizationList {
    init() {
        $(document).on("click", ".organisation-list .chevron", function (event) {
            var id = $(this).attr("data-id");
            var childContainer = $(".child-container-" + id);

            if ($(this).hasClass("active")) {
                childContainer.addClass("hidden");
                $(this).removeClass("active")
            } else {
                childContainer.removeClass("hidden");
                $(this).addClass("active")
            }
        });
    }
}



// WEBPACK FOOTER //
// ./frontend/js/components/ost.orglist.js